import React from 'react';
import { InfoIcon } from 'lucide-react';
type InfoTipProps = {
  label: string;
};
export function InfoTip({
  label
}: InfoTipProps) {
  return <span title={label} aria-label={label} role="img" className="inline-flex shrink-0 text-pf-muted" data-id="element-831" data-mp="jxw19ef5yih5">
      <InfoIcon className="h-[12px] w-[12px]" strokeWidth={1.8} data-id="element-832" data-mp="ew6sk5feygw8" />
    </span>;
}